import Doctor from "../Assets/SNS_Why_Us.png";
import SolutionStep from "./SolutionStep";
import "../Styles/About.css";

function About() {
  return (
    <div className="about-section" id="about">
      <div className="about-image-content">
        <img src={Doctor} alt="Doctor Group" className="about-image1" />
      </div>

      <div className="about-text-content">
        <h3 className="about-title">
          <span>About Us</span>
        </h3>
        <p className="about-description">
         Welcome to SNS Enterprises, your trusted partner in premium granite manufacturing and export. 
         We specialize in supplying South Indian flamed and polished granites crafted with precision to meet the standards of European outdoor architecture. 
         Our product range includes slabs and tiles offered in multiple finishes such as honed, flamed, and lepothra, ensuring versatility for diverse design and construction needs. 
         With a focus on quality, reliability, and timely shipment, we are dedicated to delivering excellence that enhances urban spaces across the world.
        </p>

        <h4 className="about-text-title">Your Solutions</h4>

        <SolutionStep
          title="Select Your Stone"
          description="Explore our exclusive range of flamed grey and polished granites, sourced from the finest quarries in Tamil Nadu. Choose the perfect texture, finish, and size to complement your architectural or landscaping project."
        />

        <SolutionStep
          title="Customize Your Order"
          description="Every project deserves a personal touch. We offer custom dimensions, surface treatments, and precision calibration to ensure consistent color uniformity and finish quality that align with European design standards."
        />

        <SolutionStep
          title="Get Global Delivery"
          description="Our products are professionally packed in strong wooden crates suitable for 20 ft and 28 ft containers, ensuring safe handling and on-time global delivery. With SNS Enterprises, you receive durability, precision, and elegance — delivered worldwide."
        />
      </div>
    </div>
  );
}

export default About;
